import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GroupForbiddenComponent } from './components/exception/forbidden/group-forbidden/group-forbidden.component';
import { InternalErrorComponent } from './components/exception/internal/internal-error/internal-error.component';
import { NotfoundComponent } from './components/exception/notfound/notfound/notfound.component';
import { AcceptInviteComponent } from './components/invites/accept/accept.invite.component';
import { AdminPanelGuard } from './services/guards/auth/admin-panel.guard';
import { AuthGuard } from './services/guards/auth/auth.guard';
import { LoginGuard } from './services/guards/auth/login.guard';
import { UserLoadedGuard } from './services/guards/auth/user-loaded.guard';
import { ExceptionViewGuard } from './services/guards/exception-view.guard';
import { ExceptionGuard } from './services/guards/exception.guard';

const routes: Routes = [
  { path: 'login', loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule), canActivate: [LoginGuard, ExceptionGuard] },
  { path: 'login/recover', loadChildren: () => import('./components/recovery/recovery.module').then(m => m.RecoveryModule), canActivate: [LoginGuard, ExceptionGuard] },

  // Requires user to be signed in
  { path: 'logout', loadChildren: () => import('./components/logout/logout.module').then(m => m.LogoutModule), canActivate: [AuthGuard, UserLoadedGuard, ExceptionGuard] },
  { path: 'dashboard', loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard, UserLoadedGuard, ExceptionGuard] },
  { path: 'management/me', loadChildren: () => import('./components/account/account.module').then(m => m.AccountModule), canActivate: [AuthGuard, UserLoadedGuard, ExceptionGuard] },
  { path: 'management/administration', loadChildren: () => import('./components/administration/administration.module').then(m => m.AdministrationModule), canActivate: [AuthGuard, UserLoadedGuard, AdminPanelGuard, ExceptionGuard] },
  // Errors
  { path: 'error/500', component: InternalErrorComponent, canActivate: [AuthGuard, ExceptionViewGuard] },
  { path: 'error/403', component: GroupForbiddenComponent, canActivate: [AuthGuard, UserLoadedGuard, ExceptionViewGuard] },
  // User doesn't have to be signed in for this routes to work.
  { path: 'invite/accept', loadChildren: () => import('./components/invites/accept/accept.invite.module').then(m => m.AcceptInviteModule), canActivate: [LoginGuard, ExceptionGuard] },
  { path: 'error/404', component: NotfoundComponent },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  // Catch invalid links
  { path: '**', redirectTo: 'error/404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
